import React from 'react';
import { Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { config, environment, isTest, isProduction } from '../config';

interface EnvironmentInfoProps {
  showVersion?: boolean;
  showDetails?: boolean;
  size?: 'small' | 'default' | 'large';
}

const EnvironmentInfo: React.FC<EnvironmentInfoProps> = ({
  showVersion = true,
  showDetails = false,
  size = 'default'
}) => {
  const getEnvironmentColor = () => {
    if (isProduction) return 'green';
    if (isTest) return 'orange';
    return 'blue';
  };

  const getEnvironmentName = () => {
    if (isProduction) return 'PROD';
    if (isTest) return 'TEST';
    return 'DEV';
  };

  const getEnvironmentTooltip = () => {
    const baseInfo = `环境: ${environment}\n版本: ${config.appVersion}`;
    
    if (showDetails) {
      return `${baseInfo}\nAPI: ${config.apiBaseUrl}\n调试: ${config.features.enableDebug ? '开启' : '关闭'}\n分析: ${config.features.enableAnalytics ? '开启' : '关闭'}`;
    }
    
    return baseInfo;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Tag 
        color={getEnvironmentColor()} 
        style={{ margin: 0 }}
      >
        {getEnvironmentName()}
      </Tag>
      
      {showVersion && (
        <Tag 
          color="default" 
          style={{ margin: 0 }}
        >
          v{config.appVersion}
        </Tag>
      )}
      
      {showDetails && (
        <Tooltip title={getEnvironmentTooltip()} placement="bottom">
          <InfoCircleOutlined 
            style={{ 
              color: '#999', 
              fontSize: size === 'small' ? '12px' : size === 'large' ? '16px' : '14px',
              cursor: 'pointer'
            }} 
          />
        </Tooltip>
      )}
    </div>
  );
};

export default EnvironmentInfo; 